<template>
    <div class="lily-audio">
        <audio
            preload="auto"
            v-if="realSrc"
            :src="realSrc"
            controls
            ref="audio"
            @loadedmetadata="onLoad"
            @timeupdate="onProgress"
            @ended="onEnd"
        ></audio>
        <!-- 控制器 -->
        <div class="lily-audio-control" @click="onStopPropagation($event)">
            <button :class="['btn-ctrl', paused ? 'is-play' : '']" @click="onPlay($event)"></button>
            <div class="progress">
                <span class="time current-time">{{ source.currentTime }}</span>
                <div class="progress-line" @click="onPoint($event)" ref="progress">
                    <span class="line" :style="{ width: percent }"></span>
                </div>
                <span class="time duration">{{ source.duration }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import version from "@/utils/version";
export default {
    name: "LilyAudio",
    props: {
        src: {
            type: String,
        },
    },
    data() {
        return {
            source: {
                duration: "00:00", // 总时长
                currentTime: "00:00",
            },
            paused: false,
            percent: 0,
            realSrc: "",
        };
    },
    watch: {
        "source.currentTime"() {
            this.percent = `${(this.$refs.audio.currentTime / this.$refs.audio.duration) * 100}%`;
        },
    },
    created() {
        if (version.isAndroid) {
            this.realSrc = this.src.replace(/"/g, "");
        } else {
            this.realSrc = this.src;
        }
    },
    methods: {
        /** 第一个字节加载 */
        onLoad() {
            this.source.duration = this._formatTime(this.$refs.audio.duration);
            this.progressWidth = parseInt(window.getComputedStyle(this.$refs.progress, null).width);
        },
        /** 播放/暂停 */
        onPlay() {
            if (this.$refs.audio.paused) {
                this.source.duration === this.source.currentTime ? (this.$refs.audio.currentTime = 0) : "";
                this.$refs.audio.play();
            } else {
                this.$refs.audio.pause();
            }

            this.paused = !this.$refs.audio.paused;
        },
        /** 播放中 */
        onProgress() {
            if (!this.$refs.audio) {
                return;
            }
            this.source.currentTime = this._formatTime(this.$refs.audio.currentTime);
        },
        /** 播放结束 */
        onEnd() {
            this.paused = false;
            //增加语音时长比较短的时候进度条展示问题
            this.percent = "100%";
        },
        /** 防止点穿 */
        onStopPropagation(e) {
            e.preventDefault();
            e.stopPropagation();
        },
        /** 进度条上的点击 */
        onPoint(e) {
            const percent = e.offsetX / this.progressWidth;
            this.$refs.audio.currentTime = this.$refs.audio.duration * percent;
            this.source.currentTime = this._formatTime(this.$refs.audio.currentTime);
            this.source.duration = this._formatTime(this.$refs.audio.duration);
            this.percent = `${percent * 100}%`;
        },
        _formatTime(time) {
            let mm = parseInt(time / 60);
            let ss = parseInt(time - mm * 60);

            return `${this._padStart(mm)}:${this._padStart(ss)}`;
        },
        _padStart(anyNum) {
            return anyNum > 9 ? anyNum : `0${anyNum}`;
        },
    },
};
</script>

<style lang="stylus" scoped>
$primary-color= #a8d9ff;

.lily-audio {
  width: 100%;
  height: 40px;
  display: inline-block;
  position: relative;

  audio {
    opacity: 0;
    height: 40px;
    width: 100%;
  }
  .lily-audio-control {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    line-height: 40px;
    .btn-ctrl {
      position: absolute;
      top: 50%;
      left: 10px;
      transform: translateY(-50%);
      width: 20px;
      padding: 0;
      margin: 0;
      cursor: pointer;
      height: 16px;
      border-style: solid;
      border-width: 8px 0 8px 13px;
      border-color: transparent transparent transparent rgba( $primary-color,  0.7);
      transition: all 0.2s ease;
      background-color: transparent;
      outline: none;
      &.is-play {
        border-style: double;
        border-width: 0 0 0 13px;
      }
    }
    .progress {
      margin-left: 20px;
      position: relative;
      height: 40px;
      .time {
        position: absolute;
        top: 0;
        display: inline-block;
        width: 50px;
        text-align: center;
        color: rgba( $primary-color,  0.8);
        font-size: 12px;
        &.current-time {
          left: 0;
        }
        &.duration {
          right: 0;
        }
      }
      .progress-line {
        position: absolute;
        left: 0;
        right: 0;
        top: 50%;
        margin: 0 50px;
        transform: translateY(-50%);
        border-radius: 4px;
        height: 4px;
        box-sizing: border-box;
        background-color: rgba( $primary-color,  0.3);
        cursor: pointer;
        .line {
          position: absolute;
          left: 0;
          height: 4px;
          border-radius: 4px;
          display: inline-block;
          max-width: 100%;
          background-color: rgba( $primary-color,  0.8);
          transition: width 0.2s ease;
          cursor: pointer;
          margin: 0;
        }
      }
    }
  }
}
</style>
